import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';
import _ from 'lodash';

import { E勘定科目カテゴリ, E取込データ種別 } from '@/openapi/enum';
import { 勘定科目ListItemResponse, 取込Pdf決算書ListItemRequest } from '@/openapi/user';

import InputableText from '@/components/inputableText/InputableText.vue';
import C勘定科目Select from '@/components/勘定科目/select/勘定科目Select.vue';
import C勘定科目大分類Select from '@/components/勘定科目/大分類Select/勘定科目大分類Select.vue';
import C勘定科目中分類Select from '@/components/勘定科目/中分類Select/勘定科目中分類Select.vue';

import { InputableTextMixin } from '@/components/inputableText/InputableText';
import 取込Mixin from '@/entries/user/mixins/取込Mixin';

export type Pdf決算書Tab = {
  取込データ種別: E取込データ種別;
  list: Pdf決算書Row[];
};

export type Pdf決算書Row = {
  selected勘定科目: 勘定科目ListItemResponse | null;
  strValue: string;
  etc: string;
  isInMaster: boolean;
  request: 取込Pdf決算書ListItemRequest;
};

export default mixins(InputableTextMixin, 取込Mixin).extend({
  name: 'Pdf決算書Tab',

  props: {
    pdf決算書Tab: {
      type: Object as PropType<Pdf決算書Tab>,
    },
  },

  components: {
    InputableText,
    C勘定科目Select,
    C勘定科目大分類Select,
    C勘定科目中分類Select,
  },

  computed: {
    e勘定科目カテゴリ(): E勘定科目カテゴリ {
      return this.getCカテゴリFrom取込データ種別(this.pdf決算書Tab.取込データ種別);
    },
    カテゴリ勘定科目s(): 勘定科目ListItemResponse[] {
      return this.filter勘定科目(this.pdf決算書Tab.取込データ種別);
    },
    is販管費(): boolean {
      return this.pdf決算書Tab.取込データ種別 === E取込データ種別.販売費および一般管理費内訳書;
    },
    list(): Pdf決算書Row[] {
      return this.pdf決算書Tab.list;
    },
  },

  methods: {
    change勘定科目(勘定科目ListItem: 勘定科目ListItemResponse | null, 決算書row: Pdf決算書Row): void {
      const isInMaster = 勘定科目ListItem !== null;
      決算書row.isInMaster = isInMaster;

      const request = 決算書row.request;
      request.勘定科目Pk = 勘定科目ListItem?.pk;
      if (isInMaster) request.取込勘定科目 = _.cloneDeep(勘定科目ListItem);
    },
    add勘定科目(決算書row: Pdf決算書Row): void {
      const 取込勘定科目 = 決算書row.request.取込勘定科目!;
      const name = 取込勘定科目.c勘定科目;
      if (name === undefined || name.length === 0) {
        window.alert('勘定科目を入力してください');
        return;
      }

      if (this.カテゴリ勘定科目s.find((勘) => 勘.c勘定科目 === name) !== undefined) {
        window.alert('この科目は既に登録済です');
        return;
      }

      this.list
        .filter((row) => row.request.取込勘定科目!.c勘定科目 === name)
        .forEach((row) => {
          row.selected勘定科目 = null;
          row.isInMaster = true;
          row.request = _.cloneDeep({ 勘定科目Pk: undefined, 取込勘定科目 });
        });
    },
    changeCell(value: string | number, row: Pdf決算書Row): void {
      this.$set(row, 'strValue', String(value));
    },
    deleteRow(index: number): void {
      this.list.splice(index, 1);
    },
  },
});
